import { useEffect, useRef, useState } from "react";
import { HandySvg } from "handy-svg";
import WhiteButton from "../UI/WhiteButton";
import useClickOutside from "../../../utils/hooks/useClickOutside";
import { getSamplers } from "../../../pages/api/apiTextToImage";
import ChainLinkIcon from "../../../public/remove_back/magic_bg/link_chain_icon.svg";
import HelpWindow from "../HelpWindow/HelpWindow";

const Sampler = ({ style, activeItem, dictionary, isLoading, changeSettings }) => {
	const [listISOpen, setListISOpen] = useState(false);
	const itemRef = useRef(null);
	const [allAiModels, setAllAiModels] = useState([]);

	useEffect(
		() => {
			const getallAiModels = async () => {
				const { data } = await getSamplers();
				setAllAiModels(data);
			};

			getallAiModels();
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[]
	);

	const listClose = () => {
		setListISOpen(false);
	};

	const listToggle = () => {
		setListISOpen(!listISOpen);
	};

	const selectItem = (item) => {
		listClose(false);
		changeSettings(item, "sampler");
	};

	useClickOutside(itemRef, listClose);

	return (
		<div ref={itemRef} className={`${style["settings-default-item"]} ${style.sampler}`}>
			<p className={style[`title`]}>
				{dictionary["sampler"] || "Sampler"}
				<HelpWindow dictionary={dictionary} name={"sampler"} />
			</p>
			<WhiteButton id="sampler-toggle" algin="left" disabled={isLoading} btnClickHandler={listToggle}>
				{activeItem?.name || allAiModels[0]?.name || "..."}
				{(activeItem?.author || allAiModels[0]?.author) && (
					<div className={style.author}>
						<ChainLinkIcon className={style.linkIcon} />
						{activeItem?.author || allAiModels[0]?.author}
					</div>
				)}

				<HandySvg className={style.icon} src={"/workspace/profile/profile_arrow.svg"} width={13} height={8} />
			</WhiteButton>
			<div id="sampler-list" className={`${style["drop-down-list"]} ${listISOpen ? style["open"] : style["close"]}`}>
				{allAiModels.map((item, index) => {
					if (item.id === activeItem?.id) return null;

					if (index === 1) {
						return (
							<button id="sampler-btn" className={style["drop-down-list_item"]} key={index} onClick={() => selectItem(item)}>
								<span>
									{item.name}
									{item.author && (
										<div className={style.author}>
											<ChainLinkIcon className={style.linkIcon} />
											{item.author}
										</div>
									)}
								</span>
							</button>
						);
					}

					return (
						<button className={style["drop-down-list_item"]} key={index} onClick={() => selectItem(item)}>
							<span>
								{item.name}
								{item.author && (
									<div className={style.author}>
										<ChainLinkIcon className={style.linkIcon} />
										{item.author}
									</div>
								)}
							</span>
						</button>
					);
				})}
			</div>
		</div>
	);
};

export default Sampler;
